import { Injectable } from '@angular/core';
import { Converter } from '../../converter.interface';
import { isNullOrUndefined } from 'util';
import { StringUtils } from 'src/app/services/utils/string.utils';
import { OrderDependencyObject } from 'src/app/models/orders/order-details-dependencies/order-dependencies.model';
import { OrderStatusObject } from 'src/app/models/orders/order-status-object.model';


@Injectable({
    providedIn: 'root'
})

export class OrderDependencyConverter implements Converter<OrderDependencyObject> {
    convert(input: any): OrderDependencyObject {
        let dependency = OrderDependencyObject.create();
        if (!isNullOrUndefined(input)) {

            const status = OrderStatusObject.createWithStatus(input.onState);

            dependency = new OrderDependencyObject(input.onWhat, input.onActivityName,
                input.onName, status, new Date(input.onDate), input.onId);
        }

        return dependency;
    }
}
